import { Component, Input } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LineItem } from '../../../../../../core/models/quotes.model';
import { Router } from '@angular/router';
import { QuotesService } from '../../../core/quotes.service';
import { take } from 'rxjs';
import { TOASTER_TYPE } from '../../../../../../components/toaster/toaster.model';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';
import { ActiveCartService } from '@spartacus/cart/base/core';

@Component({
  selector: 'quote-details-product-table',
  standalone: true,
  imports: [CommonModule, FormsModule, I18nModule],
  providers: [ActiveCartService],
  templateUrl: './quote-details-product-table.component.html',
  styleUrl: './quote-details-product-table.component.scss',
})
export class QuoteDetailsProductTableComponent {
  constructor(
    protected router: Router,
    protected quoteService: QuotesService,
    protected toasterService: ToasterService,
    protected activeCartService: ActiveCartService,
  ) {}
  @Input() lineItems!: LineItem[];

  addToCart(quoteId: string, productCode: string, quantity: number) {
    this.quoteService
      .addToCartQuoteLine(decodeURIComponent(quoteId), productCode, quantity)
      .pipe(take(1))
      .subscribe(response => {
        if (!response.hasError) {
          this.activeCartService.reloadActiveCart();
        }

        this.toasterService.init({
          type: response.hasError ? TOASTER_TYPE.DANGER : TOASTER_TYPE.SUCCESS,
          content: response.message!,
        });
      });
  }

  navigate(productCode: string) {
    this.router.navigate(['/p/' + productCode]);
  }
}
